import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zdyseachzs",
  "use": "icon-zdyseachzs-usage",
  "viewBox": "0 0 6 8",
  "content": "<symbol viewBox=\"0 0 6 8\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zdyseachzs\">\r\n<path id=\"icon-zdyseachzs_Vector\" d=\"M2.21053 -1.9325e-07L2.21053 8L6 4L2.21053 -1.9325e-07ZM0 0L0.947368 -8.28216e-08L0.947369 8L6.99382e-07 8L0 0Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol